const pt = {
    DROPDOWN_OPTIONS_ERASE_ALL: 'Apagar tudo',
    DROPDOWN_OPTIONS_BACK_BUTTON: 'Voltar',
    DROPDOWN_EMPTY_TITLE: 'Nenhum resultado encontrado',
    DROPDOWN_EMPTY_SUBTITLE: 'Tente uma palavra-chave mais geral',
    DROPDOWN_SEARCH_PLACEHOLDER: 'Pesquisar',
    DROPDOWN_LOADING: 'Carregando...',
    DROPDOWN_ERROR_TITLE: 'Erro ao carregar dados',
    DROPDOWN_ERROR_DESCRIPTION: 'Houve um problema ao carregar as informações. Por favor, tente novamente.',
    DROPDOWN_ERROR_RETRY: 'Tentar novamente'
};
const localePt = pt;
export default localePt;
